import React, { useState, useEffect } from "react";

//outsource
import { Row, Input, Modal, Button, Space, message, Popconfirm } from "antd";

//components
import { useDispatch, useSelector } from "react-redux";
import { setOpenGroupDetail } from "../../../store/var/var.action";
import { openEditGroup } from "../../../store/var/var.selector";
import { updateGroup } from "../../../store/group_service/group.action";
import { detailSelector } from "../../../store/branch/branch.selector";
import { selectedDetailGroup } from "../../../store/var/var.selector";
import { deleteTheGroup } from "../../../store/group_service/group.action";
import { DeleteOutlined } from "@ant-design/icons";

const DialogGroupDetail = () => {
  // -------------------------- VAR --------------------------

  // -------------------------- STATE --------------------------
  const [group, setGroup] = useState("");
  const [loading, setLoading] = useState(false);
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const open = useSelector(openEditGroup);
  const branch = useSelector(detailSelector);
  const selected = useSelector(selectedDetailGroup);
  const title = (
    <span>
      Edit group: "<b>{group}</b>"
    </span>
  );

  // -------------------------- FUNCTION -----------------------
  const closeOpenDialog = () => {
    dispatch(setOpenGroupDetail({ data: false }));
  };

  const handleChange = (e) => {
    const value = e.target.value;
    setGroup(value);
  };

  const handleDelete = () => {
    if (selected) {
      dispatch(
        deleteTheGroup({ id: selected?.id }, (res) => {
          if (res?.status === 200) {
            message.success("Deleted Successfully!");
            closeOpenDialog();
          } else {
            message.error(res?.data);
          }
        })
      );
    }
  };

  const handleUpdate = () => {
    if (selected && group !== "") {
      setLoading(true);
      dispatch(
        updateGroup({ group, update: selected }, (res) => {
          setLoading(false);
          if (res.status === 200) {
            message.success("Updated Successfully!");
            closeOpenDialog();
            setGroup("");
          } else {
            message.error(res.data);
          }
        })
      );
    }
  };

  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    if (selected) {
      const group = selected?.name;
      setGroup(group);
    }
  }, [selected]);
  // -------------------------- RENDER --------------------------

  const renderModalBody = () => {
    return (
      <Row>
        <Input
          placeholder="Group Name..."
          onChange={handleChange}
          value={group}
        />
      </Row>
    );
  };

  const renderFooter = () => {
    const disabled = group === "" || false;
    return (
      <Row justify="space-between">
        {renderDeleteBtn()}
        <Space>
          <Button type="default" onClick={closeOpenDialog}>
            Cancel
          </Button>
          <Button
            type="primary"
            disabled={disabled}
            onClick={handleUpdate}
            loading={loading}
          >
            Update
          </Button>
        </Space>
      </Row>
    );
  };

  const renderDeleteBtn = () => {
    return (
      <Popconfirm
        title="Are you sure to delete this group"
        okText="Yes"
        onConfirm={handleDelete}
        cancelText="No"
      >
        <Button
          type="text"
          shape="circle"
          icon={<DeleteOutlined style={{ color: "red", fontSize: 18 }} />}
        />
      </Popconfirm>
    );
  };

  // -------------------------- MAIN --------------------------
  return (
    <Modal
      title={title}
      open={open}
      onCancel={closeOpenDialog}
      footer={renderFooter()}
    >
      {renderModalBody()}
    </Modal>
  );
};

export default DialogGroupDetail;
